import { applyMiddleware, createStore, Middleware, Reducer } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

export default (reducers: Reducer, middlewares: Middleware[]) => {
  const enhancer = composeWithDevTools(applyMiddleware(...middlewares));

  return createStore(reducers, enhancer);
};
